'use client'


export default function Hero() {
  return (
    <section className="relative h-screen  bg-no-repeat bg-cover relative" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/page2_bg.png)` }} >
    </section>
  )
}